import React from 'react'
import Marquee from "react-fast-marquee";
import { Row, Col, Container } from "react-bootstrap";
import ClientGallery from '../ClientGallery';

export default function Clients() {
    return (
        <Container fluid className="py-5 clients">
            <Row className='mb-4 text-center'>
                <h4 className="">Our Trusted Partners</h4>
            </Row>
            <Row>
                <Marquee speed={50}>
                    <ClientGallery />
                </Marquee>
            </Row >
        </Container>
    )
}
